// Invite Friend Modal Web Component

class InviteFriendModal extends HTMLElement {
  constructor() {
    super();
    this.isOpen = false;
    this.isLoading = false;
  }

  connectedCallback() {
    this.render();
    this.attachEventListeners();
  }

  render() {
    this.innerHTML = `
      <div class="invite-modal ${this.isOpen ? 'open' : ''}" id="inviteModal">
        <div class="modal-backdrop" id="modalBackdrop"></div>
        <div class="modal-container">
          <div class="modal-header">
            <h3>🤝 Invite a Friend</h3>
            <button class="close-btn" id="closeBtn">×</button>
          </div>
          
          <div class="modal-body">
            <p class="modal-description">
              Invite someone to join Fun Old Times! They'll automatically become your friend when they sign up.
            </p>
            
            <form class="invite-form" id="inviteForm">
              <div class="form-group">
                <label for="email">Email address:</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  placeholder="friend@example.com"
                  required
                >
                <div class="input-hint">
                  Enter the email address where you'd like to send the invitation
                </div>
              </div>
              
              <div class="form-actions">
                <button type="button" class="btn btn-secondary" id="cancelBtn">Cancel</button>
                <button type="submit" class="btn btn-primary" id="sendBtn">
                  <span class="btn-text">Send Invitation</span>
                  <span class="btn-loading" style="display: none;">⏳ Sending...</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    // Close modal handlers
    const closeBtn = this.querySelector('#closeBtn');
    const cancelBtn = this.querySelector('#cancelBtn');
    const backdrop = this.querySelector('#modalBackdrop');
    const form = this.querySelector('#inviteForm');

    const closeModal = () => {
      this.close();
    };

    closeBtn?.addEventListener('click', closeModal);
    cancelBtn?.addEventListener('click', closeModal);
    backdrop?.addEventListener('click', closeModal);

    // Form submission
    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });

    // Keyboard handlers
    document.addEventListener('keydown', (e) => {
      if (this.isOpen && e.key === 'Escape') {
        closeModal();
      }
    });
  }


  async handleSubmit() {
    if (this.isLoading) return;

    const form = this.querySelector('#inviteForm');
    const formData = new FormData(form);
    const email = formData.get('email').trim();

    if (!email) {
      this.showError('Please enter an email address');
      return;
    }

    this.setLoading(true);

    try {
      await window.API.request('/invitations/send', {
        method: 'POST',
        body: JSON.stringify({ email })
      });

      this.showSuccess(`Invitation sent successfully to ${email}!`);
      this.close();

      // Dispatch event for other components
      this.dispatchEvent(new CustomEvent('invitation-sent', {
        detail: { email },
        bubbles: true
      }));

    } catch (error) {
      window.logger.error('Failed to send invitation:', error);
      this.showError(error.message || 'Failed to send invitation');
    } finally {
      this.setLoading(false);
    }
  }

  setLoading(loading) {
    this.isLoading = loading;
    const sendBtn = this.querySelector('#sendBtn');

    if (loading) {
      sendBtn.classList.add('loading');
      sendBtn.disabled = true;
    } else {
      sendBtn.classList.remove('loading');
      sendBtn.disabled = false;
    }
  }

  showSuccess(message) {
    const successDiv = document.createElement('div');
    successDiv.className = 'alert alert-success';
    successDiv.textContent = message;
    successDiv.style.position = 'fixed';
    successDiv.style.top = '20px';
    successDiv.style.right = '20px';
    successDiv.style.zIndex = '10001';
    successDiv.style.animation = 'fadeIn 0.3s ease-in-out';

    document.body.appendChild(successDiv);

    setTimeout(() => successDiv.remove(), 4000);
  }

  showError(message) {
    const errorDiv = document.createElement('div');
    errorDiv.className = 'alert alert-error';
    errorDiv.textContent = message;
    errorDiv.style.position = 'fixed';
    errorDiv.style.top = '20px';
    errorDiv.style.right = '20px';
    errorDiv.style.zIndex = '10001';
    errorDiv.style.animation = 'fadeIn 0.3s ease-in-out';

    document.body.appendChild(errorDiv);

    setTimeout(() => errorDiv.remove(), 4000);
  }

  open() {
    this.isOpen = true;
    this.render();
    this.attachEventListeners();

    // Focus the email input
    setTimeout(() => {
      const emailInput = this.querySelector('#email');
      emailInput?.focus();
    }, 100);
  }

  close() {
    this.isOpen = false;
    this.render();
    this.attachEventListeners();
  }
}

// Register the custom element
customElements.define('invite-friend-modal', InviteFriendModal);
